module.exports = __webpack_public_path__ + "static/media/plam_mbti_kakao.3819ab2f.jpg";